module.exports = __webpack_public_path__ + "images/2e3b2d043d133319b7f8dd7d4ae4bb44.svg";